module.exports = __webpack_public_path__ + "images/category_lp/bike/assessment_achievements/4_b4bef17499a8f92a96b4f62e9dbff79d.jpg";